<template>
  <div>
    <div v-if="!isLoading">
      <mu-card-header titleClass="boldTitle largeTitle" :title="title" :subTitle="subTitle"></mu-card-header>
      <mu-card-text>


        <mu-select-field :maxHeight="246" label="Ethnicity" v-model="model.ethnicity_id" separator=", " fullWidth>
          <mu-menu-item v-for="item, index in lists.ethnicities" key="'allergy-' + index" :value="item.ethnicity_id"
                        :title="item.name"></mu-menu-item>
        </mu-select-field>


        <mu-select-field :maxHeight="246" label="Occupation" v-model="model.occupation_id" separator=", " fullWidth>
          <mu-menu-item v-for="item, index in lists.occupations" key="'occupation-' + index" :value="item.occupation_id"
                        :title="item.occupation_name"></mu-menu-item>
        </mu-select-field>

        <mu-row gutter>
          <mu-col desktop="50" tablet="50" width="100">
            <mu-select-field fullWidth :maxHeight="246" label="Your allergys" multiple v-model="model.allergies" separator=", ">
              <mu-menu-item v-for="item, index in lists.allergies" key="'allergy-' + index" :value="item.allergy_id"
                            :title="item.name"></mu-menu-item>
            </mu-select-field>
          </mu-col>
          <mu-col desktop="50" tablet="50" width="100">
            <mu-select-field fullWidth :maxHeight="246" label="Dietary preference" v-model="model.dietry_preference_id"
                             separator=", ">
              <mu-menu-item v-for="(item, index) in lists.dietry_preferences" key="'dpref-' + index"
                            :value="item.dietry_preference_id"
                            :title="item.name"></mu-menu-item>
            </mu-select-field>
          </mu-col>
        </mu-row>
      </mu-card-text>
      <mu-card-actions align="center">
        <mu-raised-button
          class="large"
          @click="submitForm()"
          secondary
          :disabled="isSaving"
          :label="isSaving ? 'Updating...' : 'Update'"
        ></mu-raised-button>
      </mu-card-actions>
    </div>
    <mu-flexbox v-if="isLoading" justify="center center" align="center center" style="height: 316px;">
      <mu-flexbox-item align="center">
        <mu-circular-progress :size="46"></mu-circular-progress>
        <br/>
        <span v-text="$t('message.loadingText')"></span>
      </mu-flexbox-item>
    </mu-flexbox>
  </div>
</template>
<script>

  import UserApi from '../../api/User'
  import ListApi from '../../api/Lists'


  export default {
    name: 'settings-personalize',
    data() {
      return {
        title: "Personalise your program",
        subTitle: "Update your personal info",
        isSaving: false,
        isLoading: true,
        fullWidth: true,
        underlineShow: true,
        model: {},
        lists: {},
        scroller: document.getElementsByClassName('main-content')[0]
      }
    },
    mounted() {
      let self = this;
      ListApi.getGettingStartedList()
        .then(function (response) {
          self.lists = response.data;

          UserApi.getUserPersonalization()
            .then(function (response) {
              self.isLoading = false;
              self.model = response.data;
            })

        });


    }
  }
</script>



// WEBPACK FOOTER //
// Personalise.vue?6aea0078